import client from "../../../api/client";

export default async function reportRoomListing(listingId, payload) {
    const response = await client.post(`/room-listings/${listingId}/report`, {
        reason: payload?.reason || "",
        description: payload?.description || "",
    });

    return response?.data || response;
}